import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../services/AppContext';

const Logout = () => {
    const { apiClient, isAuthorized, setIsAuthorized } = useContext(AppContext);
    const navigate = useNavigate();
    
    useEffect(()=>{
        if(isAuthorized){
            apiClient.logout();
            setIsAuthorized(false);
            navigate('/');
        }
    });
  };

export default Logout;